import { dispatchTwiceGetImpactVenueCo2 } from '@/domain/impact-calculate-venue/actions/utils/dispatch-twice-get-impact-venue-co2.ts';
import { reloadMonthDeclarations } from '@/domain/project-venue-month-declaration/actions/reload-month-declaration.action.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getVenueDates } from './get-venue-dates.action';

type Params = {
  dates: { name: string; date: string; presetId?: number }[];
  projectId: number;
  organisationId: number;
};

type Result = { success: boolean };

export const bulkAddVenueDates = createAppAsyncThunk(
  'projectVenueDates/bulkAddVenueDates',
  async (
    params: Params,
    { extra: { projectVenueDatesGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      const result = await projectVenueDatesGateway.bulkAdd(params);
      await dispatch(getVenueDates());
      await dispatch(reloadMonthDeclarations());
      dispatchTwiceGetImpactVenueCo2(dispatch, params.projectId);
      showSnackbarSuccess(snackbarGateway);
      return result;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('AddVenueDates.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('AddVenueDates.Message.error'));
}
